export default {
  "fontElementMap": "jjoNU",
  "wrapper": "-JX3Z",
  "pluginContainerMobile": "KICdL",
  "viewer": "Y5SsF",
  "android": "JHfad",
  "rootedTraversedContent": "sb95P",
  "atomic": "_78JuC",
  "toolbar": "D20fg",
  "block": "ySNV-"
};